export const jk = [
   { text: "-", value: null },
   { text: "Laki-laki", value: "L" },
   { text: "Perempuan", value: "P" },
];
export const kriteria = [
   { text: "Bayi", value: "Bayi" },
   { text: "Anak", value: "Anak" },
   { text: "Dewasa", value: "Dewasa" },
];

export const golDarah = [
   { text: "-", value: null },
   { text: "A", value: "A" },
   { text: "B", value: "B" },
   { text: "AB", value: "AB" },
   { text: "O", value: "O" },
   { text: "TIDAK TAHU", value: "TIDAK TAHU" },
];

export const agama = [
   { text: "-", value: null },
   { text: "KATOLIK", value: "KATOLIK" },
   { text: "ISLAM", value: "ISLAM" },
   { text: "KRISTEN", value: "KRISTEN" },
   { text: "HINDU", value: "HINDU" },
   { text: "BUDHA", value: "BUDHA" },
   { text: "KHONGHUCHU", value: "KHONGHUCHU" },
   { text: "KEPERCAYAAN LAIN", value: "KEPERCAYAAN LAIN" },
];

export const jenis = [
          { text: "Katolik - Katolik", value: "Katolik - Katolik" },
          { text: "Katolik - Islam", value: "Katolik - Islam" },
          { text: "Katolik - Kristen", value: "Katolik - Kristen" },
          { text: "Katolik - Hindu", value: "Katolik - Hindu" },
          { text: "Katolik - Budha", value: "Katolik - Budha" },
          { text: "Katolik - Konghuchu", value: "Katolik - Konghuchu" },
          { text: "Katolik - Lainnya", value: "Katolik - Lainnya" },
       ];

export const pendidikan = [
   { text: "-", value: null },
   { text: "TIDAK SEKOLAH", value: "TIDAK SEKOLAH" },
   { text: "SD", value: "SD" },
   { text: "SMP", value: "SMP" },
   { text: "SMA", value: "SMA" },
   { text: "DI-DIII", value: "DI-DIII" },
   { text: "DIV", value: "DIV" },
   { text: "S1", value: "S1" },
   { text: "S2", value: "S2" },
   { text: "S3", value: "S3" },
   { text: "SLB", value: "SLB" },
   { text: "NON FORMAL", value: "NON FORMAL" },
   { text: "LAINNYA", value: "LAINNYA" },
];

export const statusKawin = [
   { text: "-", value: null },
   { text: "LAJANG/BELUM MENIKAH", value: "LAJANG/BELUM MENIKAH" },
   { text: "MENIKAH", value: "MENIKAH" },
   { text: "DUDA", value: "DUDA" },
   { text: "JANDA", value: "JANDA" },
   { text: "LAINNYA", value: "LAINNYA" },
];

export const cacatTubuh = [
   { text: "-", value: null },
   { text: "Ya", value: "YA" },
   { text: "Tidak", value: "TIDAK" },
];

export const profesi = [
   { text: "Bidan", value: "Bidan" },
   { text: "Biarawan/Biarawati", value: "Biarawan/Biarawati" },
   { text: "Guru", value: "Guru" },
   { text: "Apoteker", value: "Apoteker" },
   { text: "Akuntan", value: "Akuntan" },
   { text: "Auditor", value: "Auditor" },
   { text: "Konsultan", value: "Konsultan" },
   { text: "Petani", value: "Petani" },
   { text: "Pekerja Media", value: "Pekerja Media" },
   { text: "Juru Masak", value: "Juru Masak" },
   { text: "Dosen", value: "Dosen" },
   { text: "Dokter", value: "Dokter" },
];

export const keterampilan = [
   { text: "Musik", value: "Musik" },
   { text: "Memasak", value: "Memasak" },
   { text: "Menyanyi", value: "Menyanyi" },
   { text: "Pembawa Acara", value: "Pembawa Acara" },
   { text: "Elektronik", value: "Elektronik" },
   { text: "Komputer", value: "Komputer" },
   { text: "Marketing", value: "Marketing" },
   { text: "Menulis", value: "Menulis" },
   { text: "Bertukang", value: "Bertukang" },
   { text: "Menari", value: "Menari" },
];

export const peranLingkungan = [
   { text: "KETUA RT", value: "KETUA RT" },
   { text: "KETUA RW", value: "KETUA RW" },
   { text: "PENGURUS RT", value: "PENGURUS RT" },
   { text: "PENGURUS RW", value: "PENGURUS RW" },
   { text: "KEPALA DESA", value: "KEPALA DESA" },
   { text: "APARATUR DESA", value: "APARATUR DESA" },
   { text: "KEPALA DUSUN", value: "KEPALA DUSUN" },
   { text: "WARGA LINGKUNGAN", value: "WARGA LINGKUNGAN" },
];

export const peranMasyarakat = [
   { text: "TOKOH MASYARAKAT", value: "TOKOH MASYARAKAT" },
   { text: "TOKOH ADAT", value: "TOKOH ADAT" },
   { text: "TOKOH PEMUDA", value: "TOKOH PEMUDA" },
   { text: "TOKOH AGAMA", value: "TOKOH AGAMA" },
   { text: "TOKOH PENDIDIKAN", value: "TOKOH PENDIDIKAN" },
   { text: "PENGGIAT ORGANISASI", value: "PENGGIAT ORGANISASI" },
   { text: "WARGA MASYARAKAT", value: "WARGA MASYARAKAT" },
];

export const peranGereja = [
   { text: "PENGURUS DPP", value: "PENGURUS DPP" },
   { text: "ROHANIAWAN", value: "ROHANIAWAN" },
   { text: "PENGURUS LINGKUNGAN", value: "PENGURUS LINGKUNGAN" },
   { text: "PEMIMPIN", value: "PEMIMPIN" },
   { text: "IBADAT", value: "IBADAT" },
   {
      text: "PENGURUS ORGANISASI KATEGORIAL",
      value: "PENGURUS ORGANISASI KATEGORIAL",
   },
   { text: "ANGGOTA LINGKUNGAN", value: "ANGGOTA LINGKUNGAN" },
];

export default {
   jk,
   agama,
   statusKawin,
   golDarah,
   pendidikan,
   kriteria,
   cacatTubuh,
   profesi,
   keterampilan,
   peranLingkungan,
   peranMasyarakat,
   peranGereja,
   jenis,
};
